import { getDisplayVehicleInfo, INotaryDetailsData } from '../../../../../types/signingAppointment/INotaryDetailsData';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faStamp } from '@fortawesome/pro-regular-svg-icons';
import { BodyTextTW, BoldBodyTextTW } from '../../../../../tailwindComponents/bodyText/BodyTextTW';
import { TextButtonTW } from '../../../../../tailwindComponents/buttonTW/TextButtonTW';
import { formatPhoneNumber } from '../../../../../utilities/shared/formatPhoneNumber';
import { Show } from '../../../../shared/Show';
import { PencilSquareIcon } from '@heroicons/react/24/outline';
import { attorneyOrNotary } from '../../../../../utilities/order/scheduling/attorneyOrNotary';
import { useSelectAppointmentFromPathParam } from '../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';

export interface NotaryDetailsProps {
  notary: INotaryDetailsData;
  onUpdateNotaryClick: () => void;
  canEdit: boolean;
}

export const NotaryDetails = ({ notary, onUpdateNotaryClick, canEdit }: NotaryDetailsProps) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();

  return (
    <div className={'flex flex-col gap-2'}>
      <section className={'flex justify-start gap-3'}>
        <div>
          <FontAwesomeIcon icon={faStamp} />
        </div>
        <div>
          <BodyTextTW>{`Assigned ${attorneyOrNotary(appointmentFromPath?.signingMethod)}`}</BodyTextTW>
        </div>
      </section>
      <section className={'flex justify-start gap-6'}>
        <div className={'flex flex-row'}>
          <Show when={!!notary.pictureUrl}>
            <img
              alt={'notary'}
              data-test-id={'notary-picture'}
              className={'mt-0.5 h-20 w-20 rounded-md object-fill'}
              src={notary.pictureUrl}
            />
          </Show>

          <div className="ml-2 flex w-full flex-col">
            <section className="flex flex-row gap-5">
              <BoldBodyTextTW>{`${notary?.firstName ?? ''} ${notary?.lastName ?? ''}`}</BoldBodyTextTW>
              <Show when={canEdit}>
                <PencilSquareIcon
                  data-test-id={'edit-notary-button'}
                  onClick={onUpdateNotaryClick}
                  className={'h-5 w-5 cursor-pointer'}
                />
              </Show>
            </section>
            <section className="flex flex-col">
              <TextButtonTW className="!text-left">{notary?.email ?? ''}</TextButtonTW>
              <TextButtonTW className="!text-left">{formatPhoneNumber(notary?.phoneNumber ?? '')}</TextButtonTW>
            </section>
            <section className={'flex w-2/5 flex-col'}>
              <Show when={!!(notary.vehicleMake ?? notary.vehicleModel ?? notary.vehicleLicensePlate)}>
                <div className={'flex flex-row gap-1'}>
                  <div>
                    <FontAwesomeIcon icon={faCar} />
                  </div>
                  <BodyTextTW>{getDisplayVehicleInfo(notary)}</BodyTextTW>
                </div>
              </Show>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
};
